export default __webpack_public_path__ + "static/media/calendarIcon.f81dd5d0.svg";